/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-return-assign */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
/* eslint-disable react/no-array-index-key */
import PropTypes from "prop-types";
import CartCard from "Components/cart-card";
import InputCounter from "@fdn/input_counter";
import Loader from "@fdn/loader";
import { IconTrash, IconCalendarTime } from "@tabler/icons";
import Shimmer from "@fdn/bs_shimmer";
import Button from "@fdn/button";
import {
	IdrConvert,
	toPositiveNum,
} from "Helpers/utils";
import PDPPopup from "Components/pdp-popup";
import dynamic from "next/dynamic";
import { formatPromoDate } from "Helpers/dateWithMoment";
import PromoShimmer from "Containers/promo-shimmer";

const Image = dynamic(
	() => import("Components/image-with-fallback"),
	{ ssr: false },
);

const PromotionMenu = dynamic(
	() => import("Components/promotion-menu"),
	{ ssr: false },
);
const Drawer = dynamic(
	() => import("Components/drawer"),
	{ ssr: false },
);
const EmptyState = dynamic(
	() => import("Components/empty-state"),
	{ ssr: false },
);
const PromosCard = dynamic(
	() => import("Components/promos-card"),
	{ ssr: false },
);

const Desktop = ({
	isOnlyVirtualProduct,
	isLoading,
	cartData,
	cartTotal,
	handleToggleAmount,
	handleToggleDelete,
	promo,
	appliedPromo,
	handleChoosePromo,
	showDrawer,
	handleShowDrawer,
	directToCheckout,
	promotionDetail,
	setPromotionDetail,
	HandleCopyText,
	handleClearPromo,
	popupShow,
	setPopupShow,
	promoErrMsg,
}) => {

	const anyLoading = (isLoading?.loader || isLoading?.cart) || false;

	if (isLoading?.full || cartData === null) {

		return (
			<div className="container">
				<div className="grid">
					<div className="col-9">
						<div className="cart-shimmer">
							<div className="head">
								<Shimmer height="15px" width="20%" />
							</div>
							<div className="content">
								<div className="column">
									<Shimmer
										key="shimmer-1-cart"
										height="15px"
										width="60%"
									/>
								</div>
								<div className="column">
									<Shimmer
										key="shimmer-2-cart"
										height="60px"
										width="20%"
									/>
								</div>
								<div className="column">
									<Shimmer
										width="60%"
										height="15px"
										key="shimmer-3-cart"
									/>
								</div>
								<div className="column">
									<Shimmer
										key="shimmer-4-cart"
										height="15px"
										width="60%"
									/>
								</div>
								<div className="column">
									<Shimmer
										key="shimmer-5-cart"
										height="15px"
										width="60%"
									/>
								</div>
							</div>
						</div>
					</div>
					<div className="col-3">
						<div className="card-shimmer card-shimmer-cart">
							<div className="head">
								<Shimmer height="15px" width="50%" />
							</div>
							<div className="content">
								<Shimmer key="shimmer-1a-cart" height="15px" width="80%" />
								<Shimmer key="shimmer-2a-cart" height="15px" width="70%" />
								<Shimmer key="shimmer-3a-cart" height="15px" width="70%" />
								<Shimmer key="shimmer-4a-cart" height="15px" width="60%" />
							</div>
						</div>
					</div>
				</div>
				<style jsx>
					{`
						.cart-shimmer {
							padding-right: 20px;
						}
						.cart-shimmer .head {
							padding: 10px 0;
						}
						.cart-shimmer .content {
							display: grid;
							grid-template-columns: 5% 35% 20% 20% 20%;
							border-top: 1px solid #DFE3E8;
							border-bottom: 1px solid #DFE3E8;
						}
						.cart-shimmer .content .column {
							padding: 15px 0;
						}
						.card-shimmer {
							border: 1px solid #DFE3E8;
						}
						.card-shimmer .head {
							display: flex;
							align-items: center;
							border-bottom: 1px solid #DFE3E8;
							padding: 10px 15px;
						}
						.card-shimmer .content {
							padding: 15px;
						}
					`}
				</style>
			</div>
		);

	}

	if (cartData && cartData.length > 0 && !isLoading?.full) {

		const disc = IdrConvert(toPositiveNum(cartTotal.discount_amount));
		const shippingDisc = toPositiveNum(cartTotal?.shipping_discount_amount || 0);
		return (
			<>
				<PDPPopup
					show={popupShow?.show}
					color={popupShow?.color}
					text={popupShow?.message}
					onHide={() => setPopupShow({
						show: false,
						color: "",
						message: "",
						withOk: false,
					})}
					withOk={popupShow?.withOk}
				/>
				<div className="container">
					<div className="grid">
						<div className="col-9">
							<div className="cart-desktop">
								<div className="title">
									<h1>Shopping Cart</h1>
								</div>
								<div className="head">
									<div className="column-product-name">
										Product
									</div>
									<div className="column-product-price">
										Price
									</div>
									<div className="column-product-qty">
										Quantity
									</div>
									<div className="column-product-amount">
										Total
									</div>
								</div>
								<div className="content">
									{
										cartData?.map((item, idx) => {

											const extAtt = item?.extension_attributes;
											const outOfStock = extAtt?.is_in_stock === 0;
											const productOptExt = item?.product_option?.extension_attributes;
											return (
												<div key={`cart-list-desktop-${String(idx)}`} className="items">
													{/* Jangan dihapus */}
													{/* <div className="column-items-check">
													<InputCheckbox
														isSelected={item.selected}
														onClick={() => handleToggleDone(item.item_id)}
													/>
												</div> */}
													<div className="column-items-product">
														<CartCard
															name={item?.name}
															attr={extAtt}
															type={item?.product_type ?? "simple"}
															options={productOptExt?.configurable_item_options}
														/>
													</div>
													<div style={{ opacity: outOfStock ? "0.5" : "1" }} className="column-items-product-price">
														<p className="price">{IdrConvert(item.price)}</p>
														{
															extAtt?.discount_label && extAtt?.regular_price && (
																<>
																	<p className="price-discount">{IdrConvert(item.extension_attributes.regular_price)}</p>
																	<p className="discount-label">{`${item.extension_attributes.discount_label} Off`}</p>
																</>
															)
														}
													</div>
													<div className="column-items-product-qty">
														{!outOfStock && (
															<InputCounter
																isMobile
																value={item.qty}
																handleIncrement={() => handleToggleAmount(item.item_id, item, "plus")}
																handleDecrement={() => handleToggleAmount(item.item_id, item, "minus")}
																handleChange={() => {}}
																disablePlus={item.qty === item.extension_attributes.max_qty}
																disableMin={item.qty === 1}
																disableInput
															/>
														)}

													</div>
													<div style={{ opacity: outOfStock ? "0.5" : "1" }} className="column-items-product-amount">
														<p className="amount">{Object.keys(cartTotal).length > 0 && IdrConvert(item.price * item.qty)}</p>
													</div>
													<div className="column-items-action">
														<span className="action-delete" onClick={() => handleToggleDelete(item.item_id)}><IconTrash stroke="1" size="22px" /></span>
													</div>
												</div>
											);

										})
									}
								</div>
							</div>
						</div>
						<div className="col-3">
							<PromotionMenu
								clearPromo={(item) => handleClearPromo(item, "code")}
								selectedPromo={appliedPromo}
								applyPromo={(code) => handleChoosePromo(code, "code")}
								clickDrawer={() => {

									handleShowDrawer("promotion", true);

								}}
								promoErrMsg={promoErrMsg}
								loadingApplied={isLoading?.cart}
							/>

							{!isLoading?.orderSummary
								? (
									<div className="order-summary">
										<div className="head">
											<p className="title">Order Summary</p>
										</div>
										<div className="content">
											<div className="price-details">
												<div className="item">
													<span>Items</span>
													<span>{cartTotal?.items_qty ?? 0}</span>
												</div>
												<div className="item">
													<span>Subtotal</span>
													<span>
														{Object.keys(cartTotal).length > 0
														&& IdrConvert(cartTotal.subtotal)}
													</span>
												</div>
												{
													cartTotal?.base_discount_amount !== 0 && (
														<div className="item">
															<span>Promotion Discount</span>
															<span>{Object.keys(cartTotal).length > 0 && `- ${disc}`}</span>
														</div>
													)
												}
											</div>
											<div className="price-amount">
												<span>Total</span>
												<span className="bold">{Object.keys(cartTotal).length > 0 && IdrConvert((cartTotal?.subtotal + cartTotal.discount_amount) ?? 0)}</span>
											</div>
											{!isOnlyVirtualProduct
											&& Object.keys(cartTotal).length > 0 && shippingDisc !== 0 && (
												<div className="other-promotions">
													<div className="item">
														<span className="bold">Other Promotion</span>
													</div>
													<div className="item">
														<span>Shipping Discount</span>
														<span>{`${IdrConvert(shippingDisc)}`}</span>
													</div>
												</div>
											)}
											<div className="action">
												<Button is_disabled={anyLoading || false} block variant="primary-bs" size="medium" font_weight="600" font_family="Creato Display" on_click={() => directToCheckout()}>CHECKOUT</Button>
											</div>
										</div>
									</div>
								) : (

									<div className="order-summary">
										<div className="head">
											<Shimmer id="order-summary-head" height="15px" width="70%" />
										</div>
										<div className="content">
											<div className="price-details">
												<div className="item">
													<Shimmer id="price-amount-left" height="15px" width="40%" />
													<Shimmer id="price-amount-right" height="15px" width="40%" />
												</div>
												<div className="item">
													<Shimmer id="price-amount-left" height="15px" width="40%" />
													<Shimmer id="price-amount-right" height="15px" width="40%" />
												</div>
												{
													cartTotal?.base_discount_amount !== 0 && (
														<div className="item">
															<Shimmer id="price-amount-left" height="15px" width="40%" />
															<Shimmer id="price-amount-right" height="15px" width="40%" />
														</div>
													)
												}
											</div>
											<div className="price-amount">
												<Shimmer id="price-amount-left" height="15px" width="40%" />
												<Shimmer id="price-amount-right" height="15px" width="40%" />
											</div>
											{Object.keys(cartTotal).length > 0 && shippingDisc !== 0 && (
												<div className="other-promotions">
													<div className="item">
														<Shimmer id="price-amount-left" height="15px" width="40%" />
													</div>
													<div className="item">
														<Shimmer id="price-amount-left" height="15px" width="40%" />
														<Shimmer id="price-amount-right" height="15px" width="40%" />
													</div>
												</div>
											)}
											<div className="action">
												<Button block variant="primary-bs" size="medium" font_weight="600" font_family="Creato Display" on_click={() => directToCheckout()}>CHECKOUT</Button>
											</div>
										</div>
									</div>
								) }
						</div>
					</div>
				</div>
				{(isLoading?.loader) && (
					<>
						<div className="fdn-loader">
							<Loader />
						</div>
						<style>
							{`
							.fdn-loader {
								position:absolute;
							}
						`}
						</style>
					</>
				)}
				<Drawer
					contentBackground="#ffffff"
					title="Ongoing Promotion"
					saveTitle="APPLY"
					show={showDrawer.promotion}
					onSave={
						promo && promo?.filter((item) => item?.selected === true || item.is_applied).length > 0
							? () => {

								handleChoosePromo(null, "code");

							}
							: null
					}
					onHide={() => {

						handleClearPromo();
						handleShowDrawer("promotion", false);

					}}
					type={promo?.length > 0 ? "type-4" : "type-2"}
					isContentFlex
					width="800px"
				>
					{
						!isLoading?.promo && promo && promo.length > 0 && promo.map((item, idx) => (
							<PromosCard
								isMobile={false}
								key={String(idx)}
								choosePromo={() => handleChoosePromo(item)}
								selected={item?.selected}
								name={item?.name}
								shortDesc={item?.short_description}
								fromDate={item?.from_date}
								toDate={item?.to_date}
								bannerImage={item?.banner_image}
								isFaded={!item?.isAvailable}
								onDetail={() => {

									setPromotionDetail(item);
									handleShowDrawer("detailPromo", true);
									handleShowDrawer("promotion", false);

								}}
							/>
						))
					}
					{!isLoading?.promo && promo && promo.length <= 0 && (
						<EmptyState
							imagePath="/images/no_promotion_available.png"
							title="No Promotion Available"
							subtitle="Sorry, there is no ongoing promotion.<br/>
									Please come back later."
						/>
					)}
					{
						isLoading.promo && (
							<PromoShimmer />
						)
					}
				</Drawer>

				<Drawer
					contentBackground="#F0F3F7"
					title="Promotion Detail"
					promoCode={promotionDetail
						&& promotionDetail.coupon.length > 0
						&& promotionDetail.coupon[0].code}
					saveTitle="COPY CODE"
					show={promotionDetail && showDrawer.detailPromo}
					onHide={() => {

						setPromotionDetail(null);
						handleClearPromo();
						handleShowDrawer("detailPromo", false);
						handleShowDrawer("promotion", false);

					}}
					onBack={() => {

						handleShowDrawer("detailPromo", false);
						handleShowDrawer("promotion", true);

					}}
					onSave={() => HandleCopyText(promotionDetail && promotionDetail.coupon[0].code)}
					type="type-4"
				>
					<div className="promo-detail">
						<div className="image">
							{promotionDetail && <Image src={promotionDetail?.banner_image} alt="promo-detail-image" />}
						</div>
						<h4 className="title">
							{promotionDetail && promotionDetail?.name}
						</h4>
						<span className="date">

							<IconCalendarTime stroke="1" />
							<span>{promotionDetail ? formatPromoDate(promotionDetail.from_date, promotionDetail.to_date) : ""}</span>
						</span>
					</div>
					<div className="promo-terms-and-conditions">

						<h4 className="title">Terms & Conditions</h4>
						<div
							className="description"
							dangerouslySetInnerHTML={{ __html: promotionDetail && promotionDetail.description }}
						/>
					</div>
				</Drawer>
				<style jsx>
					{`
						.cart-desktop {
							padding: 0 0 80px 0;
						}
						.cart-desktop .title {
							display: flex;
							align-items: center;
							justify-content: space-between;
						}
						.cart-desktop .title h1 {
							font-weight: 600;
							font-style: normal;
							font-size: 16px;
							line-height: 24px;
						}
						.cart-desktop .head {
							display: grid;
							grid-template-columns: 40% 20% 20% 20%;
							font-weight: 400;
							font-style: normal;
							font-size: 14px;
							line-height: 22px;
							color: #919EAB;
							padding: 15px;
							border-top: 1px solid #DFE3E8;
							border-bottom: 1px solid #DFE3E8;
						}
						.cart-desktop .content .items {
							display: grid;
							grid-template-columns: 40% 20% 20% 15% 5%;
							padding: 20px 15px 0 15px;
						}
						.cart-desktop .content .items div p.price,
						.cart-desktop .content .items div p.amount {
							margin: 0;
							font-weight: 700;
							font-style: normal;
							font-size: 14px;
							line-height: 22px;
						}
						.cart-desktop .content .items div p.discount-label{
							margin: 0;
							font-style: normal;
							font-weight: 500;
							font-size: 12px;
							line-height: 100%;
							color: #F7526E;
						}
						.cart-desktop .content .items div p.price-discount  {
							margin: 2px 0;
							font-style: normal;
							font-weight: 400;
							font-size: 12px;
							line-height: 18px;
							color: #919EAB;
							text-decoration: line-through;
						}
						.cart-desktop .content .items .column-items-product {
							padding: 0 10px 0 0;
						}
						.cart-desktop .content .items div span.action-delete:hover {
							cursor: pointer;
						}

						.order-summary {
							margin: 15px;
							border: 1px solid #DFE3E8;
						}
						.order-summary {
							margin: 15px;
							border: 1px solid #DFE3E8;
						}
						.order-summary .head {
							padding: 15px;
							border-bottom: 1px solid #DFE3E8;
						}
						.order-summary .head p.title {
							margin: 0;
							font-weight: 500;
							font-size: 14px;
							line-height: 16px;
						}
						.order-summary .content {
							padding: 15px;
						}
						.order-summary .content .price-details, .order-summary .content .other-promotions {
							font-weight: 400;
							font-style: normal;
							font-size: 14px;
							line-height: 22px;
						}
						.price-details {
							padding-bottom: 15px;
						}
						.other-promotions {
							padding: 8px 0 16px;
							border-top: 1px dashed #C4CDD5;
						}
						.order-summary .content .price-details {
							border-bottom: 1px dashed #C4CDD5;
						}
						.order-summary .content .price-details .item {
							display: flex;
							align-items: center;
							justify-content: space-between;
						}
						.order-summary .content .price-details .item, .order-summary .content .other-promotions .item {
							display: flex;
							align-items: center;
							justify-content: space-between;
						}
						.order-summary .content .price-details .item span.danger, .order-summary .content .other-promotions .item span.danger {
							color: #FF4D4F;
						}
						.order-summary .content .price-amount {
							display: flex;
							align-items: center;
							justify-content: space-between;
							font-weight: 400;
							font-style: normal;
							font-size: 14px;
							line-height: 22px;
							padding: 20px 0;
						}
						.order-summary .content span.bold {
							font-weight: 600;
						}

						.no-promo-avail {    
							display: flex;
							text-align: center;
							align-items: center;
							justify-content: center; 
							height: 80%;
							padding: 20px;
							background: #fff;
							color: #000000;
						}

						.no-promo-avail span .image{    
							position: relative;
							width: 180px;
							height: 161.42px;
							margin: 43px auto;
						}

						.no-promo-avail span p, .no-promo-avail span h5 {
							margin: 0;
						}

						.no-promo-avail span p {
							font-style: normal;
							font-weight: 400;
							font-size: 14px;
							line-height: 22px;
							/* or 157% */

							text-align: center;
							letter-spacing: 0.04em;

							color: #454F5B;
						}

						.no-promo-avail span h5 {
							font-style: normal;
							font-weight: 600;
							font-size: 16px;
							line-height: 24px;
							/* identical to box height, or 150% */

							text-align: center;
							letter-spacing: 0.04em;

							color: #000000;
						}

						.promo-detail,.promo-terms-and-conditions {
							display: grid;
							grid-template-columns: 1fr;
							grid-gap: 10px;
							padding: 20px;
							background: #fff;
							color: #000000;
							margin-bottom: 12px;
						}

						.promo-detail .image {
							position: relative;
							width: 612px;
							height: 306px;
						}

						.promo-detail .title, .promo-terms-and-conditions > .title{
							font-style: normal;
							font-weight: 600;
							font-size: 16px;
							line-height: 24px;
							letter-spacing: 0.04em;
							margin: 0;
							color: #000000;
						}

						.promo-detail .date {
							display: flex;
							align-items: center;
						}
						.promo-detail .date span {
							font-style: normal;
							font-weight: 400;
							font-size: 14px;
							line-height: 22px;
							margin: 0 10px;
						}
						.promo-terms-and-conditions .description {
							font-style: normal;
							font-weight: 400;
							font-size: 14px;
						}
					`}
				</style>
			</>
		);

	}

	return (
		<>
			<div className="empty-cart">
				<span>
					Your cart is still empty
				</span>
				<Button
					variant="primary-bs"
					font_family="Creato Display"
					font_weight="500"
					on_click={() => window.location.href = `${process.env.NEXT_PUBLIC_ROOT_DOMAIN}`}
				>
					START SHOPPING

				</Button>
			</div>
			<style jsx>
				{`
					.empty-cart{
						height: 500px;
						width: max-content;
						display: flex;
						flex-direction: column;
						justify-content: center;
						margin: 0 auto;
					}
					.empty-cart span{
						font-size: 14px;
						font-style: normal;
						font-weight: 400;
						line-height: 22px;
						letter-spacing: 0em;
						margin-bottom: 16px;
					}
				`}
			</style>
		</>
	);

};

Desktop.propTypes = {
	isOnlyVirtualProduct: PropTypes.bool,
	isLoading: PropTypes.bool,
	cartData: PropTypes.any,
	cartTotal: PropTypes.any,
	handleToggleAmount: PropTypes.func,
	handleToggleDelete: PropTypes.func,
	promo: PropTypes.any,
	appliedPromo: PropTypes.array,
	handleChoosePromo: PropTypes.func,
	showDrawer: PropTypes.any,
	handleShowDrawer: PropTypes.func,
	directToCheckout: PropTypes.func,
	promotionDetail: PropTypes.any,
	setPromotionDetail: PropTypes.func,
	HandleCopyText: PropTypes.func,
	handleClearPromo: PropTypes.func,
	// isLoadingCounter: PropTypes.bool,
	// cartLoading: PropTypes.bool,
	popupShow: PropTypes.any,
	setPopupShow: PropTypes.func,
	promoErrMsg: PropTypes.any,
	// isLoadCartTotal: PropTypes.bool,
};

export default Desktop;
